<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar class="vx-navbar navbar-custom navbar-skelton" :color="navbarColorLocal" :class="textColor">

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />

        <span class="mr-2">{{ company.name }}</span>

         <div class="flex items-center gap-1">
          <vs-button
            icon
            @click="prevYear"
            :disabled="selectedYear === Math.min(...yearOptions)"
          >
            ‹
          </vs-button>

          <!-- select year! -->
          <vs-select
            v-model="selectedYear"
            placeholder="Pilih Tahun"
          >
            <vs-select-item
              v-for="year in yearOptions"
              :key="year"
              :value="year"
              :text="year.toString()"
            />
          </vs-select>

          <vs-button
            icon
            @click="nextYear"
            :disabled="selectedYear === Math.max(...yearOptions)"
          >
            ›
          </vs-button>
        </div>

        <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

          <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
            <span class="mr-2">Arga Solusi Technologies</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>

            <vs-dropdown-item>
              <span class="flex items-center p-2">
                <feather-icon icon="BookIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Arga Solusi Technologies</span>
              </span>
            </vs-dropdown-item>

            <vs-dropdown-item>
              <span class="flex items-center p-2">
                <feather-icon icon="BookIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Sigi Systems</span>
              </span>
            </vs-dropdown-item>

          </vs-dropdown-menu>
        </vs-dropdown> -->

        <!-- <bookmarks :navbarColor="navbarColor" v-if="windowWidth >= 992" /> -->

        <vs-spacer />

        <i18n />

        <search-bar class="mr-6"/>

        <!-- <cart-drop-down /> -->

        <!-- <notification-drop-down /> -->

        <profile-drop-down />

      </vs-navbar>
    </div>
  </div>
</template>


<script>
// import Bookmarks            from './components/Bookmarks.vue'
import I18n                 from './components/I18n.vue'
import SearchBar            from './components/SearchBar.vue'
// import CartDropDown         from './components/CartDropDown.vue'
import NotificationDropDown from './components/NotificationDropDown.vue'
import ProfileDropDown      from './components/ProfileDropDown.vue'

export default {
  name: 'the-navbar-vertical',
  data () {
    return {
      company: JSON.parse(localStorage.getItem('activeCompany')),
      selectedYear: parseInt(localStorage.getItem('selectedYear')),
      yearOptions: this.generateYearRange(2019, new Date().getFullYear())
    }
  },
  props: {
    navbarColor: {
      type: String,
      default: '#fff'
    }
  },
  components: {
    // Bookmarks,
    I18n,
    SearchBar,
    // CartDropDown,
    NotificationDropDown,
    ProfileDropDown
  },
  watch: {
    selectedYear (newVal) {
      localStorage.setItem('selectedYear', newVal)
      this.$emit('year-changed', newVal) // Emit event for parent components
      window.location.reload()
    }
  },
  computed: {
    navbarColorLocal () {
      return this.$store.state.theme === 'dark' && this.navbarColor === '#fff' ? '#10163a' : this.navbarColor
    },
    verticalNavMenuWidth () {
      return this.$store.state.verticalNavMenuWidth
    },
    textColor () {
      return {'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark') || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')}
    },
    windowWidth () {
      return this.$store.state.windowWidth
    },

    // NAVBAR STYLE
    classObj () {
      if      (this.verticalNavMenuWidth === 'default') return 'navbar-default'
      else if (this.verticalNavMenuWidth === 'reduced') return 'navbar-reduced'
      else if (this.verticalNavMenuWidth)               return 'navbar-full'
    }
  },
  methods: {
    showSidebar () {
      this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
    },
    generateYearRange (start, end) {
      const years = []
      for (let y = start; y <= end; y++) {
        years.push(y)
      }
      return years
    },
    handleChangeYear () {
      localStorage.setItem('selectedYear', this.selectedYear)
      setTimeout(() => {
        return window.location.reload()
      }, 500)
    },
    prevYear () {
      if (this.selectedYear > Math.min(...this.yearOptions)) {
        this.selectedYear--
      }
    },
    nextYear () {
      if (this.selectedYear < Math.max(...this.yearOptions)) {
        this.selectedYear++
      }
    }
  }
}
</script>

